
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.264 26.951c-.176-.072-17.182-7.137-18.039-16.735l8.252-3.692a1.183 1.183 0 00.012-2.155L20.5.227A1.182 1.182 0 0018.817 1.3v8.167c0 9.965-17.9 17.41-18.081 17.484A1.185 1.185 0 000 28.047V38.7a1.183 1.183 0 001.183 1.183h37.634A1.182 1.182 0 0040 38.7V28.047a1.185 1.185 0 00-.736-1.096zM21.183 3.15l4.949 2.278-4.949 2.213zM2.367 28.827C5.364 27.5 16.355 22.2 20 14.488a16.287 16.287 0 001.4 2.364A35.621 35.621 0 018.1 37.515H2.367zm35.266 8.688H11.806a37.7 37.7 0 0011.47-18.36c4.785 5.155 12.012 8.632 14.357 9.672z"}})])
          )
        }
      }
    